import { ReactElement, ReactNode } from 'react'
import { Box, Tooltip, useTheme } from '@mui/material'

export type MiniTooltipButtonProps = {
  onClick: () => void
  icon: ReactNode
  label: string
  tooltip?: string
  tooltipPlacement?: 'bottom' | 'left' | 'right' | 'top'
}

const MiniTooltipButton = ({
  onClick,
  icon,
  label,
  tooltip,
  tooltipPlacement = 'top',
}: MiniTooltipButtonProps): ReactElement => {
  const theme = useTheme()
  const node = (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      sx={{
        border: '1px solid rgba(0,0,0,0.18)',
        borderRadius: 1,
        background: theme.palette.common.white,
        color: theme.palette.text.secondary,
        px: 1,
        height: 24,
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        fontFamily: 'Roboto',
        fontSize: 11,
        fontWeight: 500,
        letterSpacing: '0.02em',
        '&:hover': {
          background: theme.palette.action.hover,
          color: theme.palette.text.primary,
        },
      }}
    >
      {icon}
      {label}
    </Box>
  )
  if (!tooltip) return node
  return (
    <Tooltip title={tooltip} arrow disableInteractive placement={tooltipPlacement}>
      {node}
    </Tooltip>
  )
}

export default MiniTooltipButton
